import { render, staticRenderFns } from "./index.vue?vue&type=template&id=215da17f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=215da17f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215da17f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('215da17f')) {
      api.createRecord('215da17f', component.options)
    } else {
      api.reload('215da17f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=215da17f&scoped=true", function () {
      api.rerender('215da17f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/unitDialog/index.vue"
export default component.exports